/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Skeleton, SkeletonBlock, SkeletonLine, Alert, Typography, Badge, } from '@one-thd/sui-atomic-components';
import { WarningFilled } from '@one-thd/sui-icons';
import { rhGeneral, rhTierRewards } from '../../../../constants/RewardsHub';
import { useIsMobile } from '../../../../hooks';
import { isNewPerk } from '../../../PerksPage/shared/commons';
var constants = {
    textNoData: rhTierRewards.textNoData,
    rewardsError: rhTierRewards.rewardsError,
    genericError: rhGeneral.genericError,
};
export var LoadingSkeletonVertical = function (props) {
    var isMobile = props.isMobile, lineCountMW = props.lineCountMW, lineCountDTW = props.lineCountDTW, hideBlock = props.hideBlock, hideLines = props.hideLines, disablePadding = props.disablePadding;
    var SkellyMW = function () {
        var skeletonBlocks = Array.from({ length: lineCountMW || 2 });
        return (React.createElement("div", { "data-testid": "loading-skeleton" },
            !hideBlock &&
                skeletonBlocks.map(function (item, index) { return (React.createElement(SkeletonBlock, { key: index, aspect: "wide", height: 20 })); }),
            React.createElement("div", { className: "sui-mt-6" }),
            hideBlock && (React.createElement(SkeletonLine, { fullWidth: true, variant: lineCountMW === 1 ? 'single' : 'multi', numberOfLines: lineCountMW || 2 }))));
    };
    var SkellyDTW = function () { return (React.createElement("div", { "data-testid": "loading-skeleton" },
        !hideBlock && React.createElement(SkeletonBlock, { aspect: "square", height: 20 }),
        React.createElement("div", { className: "sui-mt-6" }),
        !hideLines && (React.createElement(SkeletonLine, { fullWidth: true, variant: "multi", numberOfLines: lineCountDTW || 2 })))); };
    return (React.createElement(Skeleton, { grow: true, disablePadding: disablePadding || disablePadding !== false || 'x' }, isMobile ? React.createElement(SkellyMW, null) : React.createElement(SkellyDTW, null)));
};
var isPerkOffer = function (perk) {
    return 'expirationTime' in perk;
};
var isChallenge = function (perk) {
    return 'challengeEndDate' in perk;
};
export var ExpirationLine = function (_a) {
    var perk = _a.perk, type = _a.type;
    if ((perk === null || perk === void 0 ? void 0 : perk.daysLeft) == null)
        return React.createElement(React.Fragment, null);
    var expireMessage = "".concat(perk === null || perk === void 0 ? void 0 : perk.daysLeft, " day").concat((perk === null || perk === void 0 ? void 0 : perk.daysLeft) < 2 ? '' : 's', " left to use ").concat(type);
    if (perk.daysLeft === 0)
        expireMessage = rhTierRewards.expiresToday;
    var creationTime = isPerkOffer(perk) ? perk === null || perk === void 0 ? void 0 : perk.activationTime : '';
    var newPerk = isNewPerk(creationTime);
    var expireDate = function (dateStr) { return (React.createElement(React.Fragment, null,
        newPerk && type === 'Perk' && (React.createElement(Badge, { variant: "strong", color: "brand" }, "New")),
        React.createElement("span", { className: "".concat(newPerk ? 'sui-ml-2' : '') },
            "Expires ",
            dateStr))); };
    return (perk === null || perk === void 0 ? void 0 : perk.daysLeft) < 14 ? (React.createElement("span", { className: "sui-flex" },
        React.createElement(WarningFilled, { color: "warning" }),
        React.createElement("span", { className: "sui-pl-2" }, expireMessage))) : (React.createElement(React.Fragment, null,
        isPerkOffer(perk) &&
            !!(perk === null || perk === void 0 ? void 0 : perk.expirationTime) &&
            expireDate(perk === null || perk === void 0 ? void 0 : perk.expirationTime),
        isChallenge(perk) &&
            !!(perk === null || perk === void 0 ? void 0 : perk.challengeEndDate) &&
            expireDate(perk === null || perk === void 0 ? void 0 : perk.challengeEndDate)));
};
export var MessageNoData = function (_a) {
    var card = _a.card;
    return (React.createElement("div", { className: "sui-max-w-[240px]" },
        React.createElement(Typography, { align: "left" }, constants.textNoData(card))));
};
export var GenericErrorRefresh = function (_a) {
    var refreshFunc = _a.refreshFunc;
    var Message = function () { return React.createElement("p", null, constants.genericError); };
    var AlertBlock = function () { return (React.createElement("div", { className: "sui-grow" },
        React.createElement(Alert, { status: "error" },
            React.createElement(Message, null),
            React.createElement("button", { type: "button", onClick: refreshFunc },
                React.createElement("u", null, "Refresh"))))); };
    return (React.createElement("div", { className: "sui-flex sui-gap-6" },
        React.createElement(AlertBlock, null)));
};
export var ErrorRefresh = function (_a) {
    var refreshFunc = _a.refreshFunc, refreshWord = _a.refreshWord;
    var AlertBlock = function () { return (React.createElement("div", { className: "sui-grow" },
        React.createElement(Alert, { status: "error" },
            React.createElement("p", null, constants.rewardsError(refreshWord)),
            React.createElement("button", { type: "button", onClick: refreshFunc },
                React.createElement("u", null, "Refresh"))))); };
    return (React.createElement("div", { className: "sui-flex sui-gap-6" },
        React.createElement(AlertBlock, null)));
};
export var ContainerImageText = function (_a) {
    var ImageComponent = _a.ImageComponent, children = _a.children, _b = _a.dimensionsMW, dimensionsMW = _b === void 0 ? '72px' : _b, _c = _a.dimensionsDTW, dimensionsDTW = _c === void 0 ? '110px' : _c, noGap = _a.noGap;
    var classGap = noGap ? '' : 'sui-gap-6 md:sui-gap-10';
    var classDimensions = "sui-h-[".concat(dimensionsMW, "] sm:sui-h-[").concat(dimensionsDTW, "] sui-w-[").concat(dimensionsMW, "] sm:sui-w-[").concat(dimensionsDTW, "]");
    // Work around until Stencil's fixed. Once fixed, return to using classDimensions
    var dimentionWorkaround = useIsMobile().isMobile
        ? { width: '72px', height: '72px' }
        : { width: '110px', height: '110px' };
    return (React.createElement("div", { className: "sui-flex ".concat(classGap, " sui-mt-0 md:sui-mt-8") },
        React.createElement("div", { className: "sui-flex sui-items-center", style: dimentionWorkaround }, !!ImageComponent && React.createElement(ImageComponent, null)),
        React.createElement("div", { className: "sui-col-span-2 sui-flex sui-flex-col sui-justify-center" }, children)));
};
